var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.answerSheet.acCardMissSign),expression:"answerSheet.acCardMissSign"}],staticClass:"basics_example_component",class:{'three-row': _vm.answerSheet.acCardPanes == 3}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"correct"},[_c('span',{staticClass:"text"},[_vm._v("正确填涂")]),_c('span',{staticClass:"correct_content content"})])
}]

export { render, staticRenderFns }